var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSaveRetDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 40,
    viewBox: "0 0 47 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12H30.3C31.4201 12 31.9802 12 32.408 11.782C32.7843 11.5903 33.0903 11.2843 33.282 10.908C33.5 10.4802 33.5 9.9201 33.5 8.8V4M13.5 8V2M21.5 22C20.3799 22 15.0198 22 14.592 22.218C14.2157 22.4097 13.9097 22.7157 13.718 23.092C13.5 23.5198 13.5 24.0799 13.5 25.2V38M29.5 22C30.6201 22 31.9802 22 32.408 22.218C32.7843 22.4097 33.0903 22.7157 33.282 23.092C33.5 23.5198 33.5 23.8799 33.5 25M33.5 38V31.6M41.5 31.6V14.651C41.5 13.6726 41.5 13.1834 41.3895 12.7231C41.2915 12.3149 41.1299 11.9247 40.9106 11.5669C40.6632 11.1632 40.3173 10.8173 39.6255 10.1255L33.3745 3.87452C32.6827 3.18271 32.3368 2.83681 31.9331 2.58944C31.5753 2.37012 31.1851 2.20851 30.7769 2.11052C30.3166 2 29.8274 2 28.849 2H15.1C11.7397 2 10.0595 2 8.77606 2.65396C7.64708 3.2292 6.7292 4.14708 6.15396 5.27606M40.846 34.7239C40.2708 35.8529 39.3529 36.7708 38.2239 37.346C36.9405 38 35.2603 38 31.9 38H15.1C11.7397 38 10.0595 38 8.77606 37.346C7.64708 36.7708 6.7292 35.8529 6.15396 34.7239C5.5 33.4405 5.5 31.7603 5.5 28.4V8M40.846 34.7239L6.15396 5.27606M40.846 34.7239L45.5 39M6.15396 5.27606L1.5 1",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSaveRetDark);
export default __webpack_public_path__ + "static/media/no-save-ret-dark.def48a0b2a1484732f3ecf0b278bd3ce.svg";
export { ForwardRef as ReactComponent };